(function ($) {
  $(window).on('load', () => {
    /* parseUri.options.strictMode = true;
        var url = parseUri(window.location.href);
        if(parseInt(url.queryKey.reserve) === 1){
            return openReserveOverlay();
        } */
  });

  $(document).ready(() => {
    const nav = $('.nav');
    const montageReserve = $('#reserve-montage');
    const pendryReserve = $('#reserve-pendry');

    const $overlay = $('.reservation-overlay');
    const $button = $('#open-reservation-overlay');
    const $cross = $('#close-reservation-overlay');

    /**
     * Close reserve overlay
     * @return void
     */
    function closeReseveOverlay() {
      $('body').removeClass('overflow-hidden');
      $button.removeClass('d-none');
      $cross.parent('.c-button--reservation-close').addClass('d-none');
      $overlay.slideUp();
      $button.focus();
    }

    nav.on('open', () => {
      closeReseveOverlay();
    });

    /**
     * Open reserve overlay
     * @return void
     */
    function openReserveOverlay() {
      $('body').addClass('overflow-hidden');
      $button.addClass('d-none');
      $cross.parent('.c-button--reservation-close').removeClass('d-none');
      $overlay.slideDown({
        start() {
          $(this).css({
            display: 'flex',
          });
        },
      });
      $cross.focus();
    }

    $button.on('click', () => {
      openReserveOverlay();

      if ($('.c-hamburger').hasClass('open')) {
        $('.c-hamburger').trigger('click');
      }
    });

    $cross.on('click', () => {
      closeReseveOverlay();
    });

    $cross.on('keydown', (event) => {
      if (event.keyCode === 9) {
        montageReserve.focus();
        event.preventDefault();
      }
    });

    pendryReserve.on('keydown', (event) => {
      if (event.keyCode === 9) {
        $cross.focus();
        event.preventDefault();
      }
    });

    $('#reserve-montage, #reserve-pendry').on('change', function (event) {
      const value = $(this).val();

      if (value) {
        $(this).val('');
        window.location.href = value;
      }

      event.preventDefault();
      return false;
    });
  });
}(jQuery));
